import React from 'react';
import { Grid, IconButton, Typography } from '@mui/material';
import { ChevronRight, ChevronLeft } from '@mui/icons-material';
import { useStore, useMItem } from 'store';
import { useBillboardProps } from './useBillboardProps';

export type BillboardViewerTitleProps = {
  title: string;
};

export const BillboardViewerTitle = ({ title }: BillboardViewerTitleProps) => {
  const billboardProps = useBillboardProps();
  const { onPrev, onNext, current = 0, total = 0 } = billboardProps;
  const board_type = useStore((state) => state.scene_controls.board_type);

  if (total < 1) {
    return null;
  }

  return (
    <Grid container spacing={2} item xs={12} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <Grid item>
        {board_type === 'mixed' && (
          <IconButton onClick={onPrev} disabled={current === 1}>
            <ChevronLeft />
          </IconButton>
        )}
      </Grid>

      <Grid item>
        <Typography variant="h6" align="center" sx={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          maxWidth: 430,
        }}>
          {title}
        </Typography>
      </Grid>

      <Grid item>
        {board_type === 'mixed' && (
          <IconButton onClick={onNext} disabled={(current || 0) >= (total || 0)}>
            <ChevronRight />
          </IconButton>
        )}
      </Grid>

    </Grid>
  );
};